__turbopack_context__.v({
  "fullpagewrapper": "CHZOLG_fullpagewrapper",
});
